import React from 'react';
import { PieChart as RePieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartCard } from '../../dashboard';

export default function PieChart({ title, data = [] }) {
  const total = data.reduce((sum, d) => sum + (d.value || 0), 0);

  const legend = total ? (
    <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[11px] text-gray-600">
      {data.map((d) => (
        <span key={d.name} className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: d.color }} />
          {d.name} <span className="font-semibold text-gray-800">{d.value}</span>
        </span>
      ))}
    </div>
  ) : null;

  return (
    <ChartCard title={title} empty={!total} emptyHeight={180} footer={legend}>
      <div className="h-full flex items-center justify-center">
        <ResponsiveContainer width="100%" height={180}>
          <RePieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius={48}
              outerRadius={72}
              paddingAngle={data.length > 1 ? 2 : 0}
            >
              {data.map((entry, i) => (
                <Cell key={i} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12, border: '1px solid #e5e7eb' }} />
          </RePieChart>
        </ResponsiveContainer>
      </div>
    </ChartCard>
  );
}
